module.exports = __webpack_public_path__ + "static/media/mode15.298f907e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode15.gif
// module id = 1331
// module chunks = 114